type Props = React.SVGAttributes<SVGElement> & {
  iconColor?: string
}

export const VerticalListIcon = ({
  iconColor = 'currentColor',
  ...props
}: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 2H3C2.44772 2 2 2.44772 2 3V9C2 9.55229 2.44772 10 3 10H13C13.5523 10 14 9.55229 14 9V3C14 2.44772 13.5523 2 13 2Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M2 12.3334H14"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M2 14.3334H10"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
    </svg>
  )
}
